import { AnyAction } from 'redux';
import { ProviderListFilter } from '@utils/tables/providers/providerListFilter';
import { ProviderItemDto } from '@contracts/api/dto/providers/ProviderDto';
import { ConfigListFilter } from '@utils/tables/configs/configListFilter';

export type FilterType = {
  key: string;
  value: string | number;
};

export type ProvidersTableFilters = {
  id?: string;
  name?: string;
  status?: 'ACTIVE' | 'INACTIVE';
  syncRoundEnd?: boolean;
  retryScheduledSendCredit?: boolean;
  refundOnCreditFail?: boolean;
};

export interface ProviderTableInterface {
  selectedFilters: ProviderListFilter;
  columnVisibility: ProviderListFilter;
  columnVisibilityOptions: ProviderListFilter;
  providersTableFilters: ProvidersTableFilters;
  currentTab: number;
  setColumnVisibility: () => AnyAction;
  setProvidersTableFilters: (arg: FilterType) => AnyAction;
  setCurrentTab: (arg: number) => AnyAction;
}

export interface CreateProviderReducerInterface {
  showCreateProviderForm: boolean;
  showCancelProviderForm: boolean;
  setShowCreateProviderForm: (arg: boolean) => AnyAction;
  setShowCancelProviderForm: (arg: boolean) => AnyAction;
}

export interface CreateProviderConfigReducerInterface {
  showCreateProviderConfigForm: boolean;
  showCancelProviderConfigForm: boolean;
  setShowCreateProviderConfigForm: (arg: boolean) => AnyAction;
  setShowCancelProviderConfigForm: (arg: boolean) => AnyAction;
}

export interface CurrencyInterface {
  betSuggestions: number[];
  createdAt: string;
  currency: string;
  defaultAutoCashout: number;
  defaultBet: number;
  id: string;
  maxAutoCashout: number;
  maxBet: number;
  maxWin: number;
  minAutoCashout: number;
  minBet: number;
  providerId: string;
  updatedAt: string;
}

interface SelectedConfigInterface {
  betSuggestions: number[];
  createdAt: string;
  currency: string;
  defaultAutoCashout: number;
  defaultBet: number;
  id: string;
  maxAutoCashout: number;
  maxBet: number;
  maxWin: number;
  minAutoCashout: number;
  minBet: number;
  providerId: string;
  updatedAt: string;
  isRoundable: string | boolean;
  allowedBetType: string;
}

export interface UpdateProviderConfigReducerInterface {
  showUpdateProviderConfigForm: boolean;
  showCancelUpdateProviderConfigForm: boolean;
  selectedProviderConfig: SelectedConfigInterface;
  showDeleteProviderConfigForm: boolean;
  setShowUpdateProviderConfigForm: (arg: boolean) => AnyAction;
  setShowCancelUpdateProviderConfigForm: (arg: boolean) => AnyAction;
  setSelectedProviderConfig: () => AnyAction;
  setShowDeleteProviderConfigForm: (arg: boolean) => AnyAction;
}

export interface UpdateMinesProviderConfigReducerInterface {
  showUpdateMinesProviderConfigForm: boolean;
  showCancelUpdateMinesProviderConfigForm: boolean;
  selectedMinesProviderConfig: SelectedConfigInterface;
  setShowUpdateMinesProviderConfigForm: (arg: boolean) => AnyAction;
  setShowCancelUpdateMinesProviderConfigForm: (arg: boolean) => AnyAction;
  setSelectedMinesProviderConfig: () => AnyAction;
}

type ExistingCurrencies = {
  currency: string;
  reason: string;
};

export interface ProviderDrawerReducerInterface {
  selectedProviderData: ProviderItemDto;
  selectedCurrency: CurrencyInterface;
  showProviderDrawer: boolean;
  showDeleteProviderModal: boolean;
  showCancelProviderDrawer: boolean;
  showCurrencyModal: boolean;
  showCurrencyUploadAlertModal: boolean;
  existingCurrencies: ExistingCurrencies[];
  currencyFile: File | null;
  setCurrencyFile: (arg: File) => AnyAction;
  setShowProviderDrawer: (arg: boolean) => AnyAction;
  setShowCancelProviderDrawer: (arg: boolean) => AnyAction;
  setSelectedCurrency: (arg: CurrencyInterface) => void;
  setShowCurrencyModal: (arg: CurrencyInterface) => AnyAction;
  setShowCurrencyUploadAlertModal: (arg: boolean) => AnyAction;
  setExistingCurrencies: (arg: ExistingCurrencies[]) => AnyAction;
}

export type ConfigTableFilterType = {
  providerId: string;
  currency: string;
  maxWin: number;
  minBet: number;
  maxBet: number;
  isRoundable: boolean;
};

export interface ConfigsTableInterface {
  selectedFilters: ConfigListFilter;
  columnVisibility: ConfigListFilter;
  columnVisibilityOptions: ConfigListFilter;
  configTableFilters: ConfigTableFilterType;
  setColumnVisibility: () => AnyAction;
  setConfigTableFilters: (arg: FilterType) => AnyAction;
}

export const ProvidersTableGames = {
  1: 'Aviator',
  2: 'Mines',
  3: 'Rubber Duck',
} as const;

export type ProvidersTableGamesKeys = keyof typeof ProvidersTableGames;
